import { render, staticRenderFns } from "./redPacketrecord.vue?vue&type=template&id=8f345ae4&scoped=true&"
import script from "./redPacketrecord.vue?vue&type=script&lang=js&"
export * from "./redPacketrecord.vue?vue&type=script&lang=js&"
import style0 from "./redPacketrecord.vue?vue&type=style&index=0&id=8f345ae4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f345ae4",
  null
  
)

export default component.exports